module.exports = __webpack_public_path__ + "static/media/top-user-banner-4.525e2e7c.jpg";